<template>
  <div id="blade2">
    <blade2a />
    <blade2b />
  </div>
</template>

<script>
import Blade2a from "./blade2-sections/Blade2a";
import Blade2b from "./blade2-sections/Blade2b";

export default {
  name: "Blade2",
  components: {
    Blade2a,
    Blade2b
  }
};
</script>

<style lang="scss">
#blade2 {
  background-color: #000;

  @include media-breakpoint-up(xs) {
    padding: 0;
  }
  @include media-breakpoint-down(sm) {
    .container {
      max-width: 100%;
    }
  }
  @include media-breakpoint-up(md) {
    padding: 50px 40px;
  }
  @include media-breakpoint-up(lg) {
    padding: 100px 50px;
  }
  @include media-breakpoint-up(xl) {
    padding: 100px 70px;

    .container {
      max-width: 1140px;
    }
  }
}
</style>